import $ from "jquery";
import "popper.js"; // Bootstrap requires this
import "bootstrap";
import "fslightbox";
import "./js/cookies.js";
import "./js/smooth-scroll.js";
import Player from "@vimeo/player";

//import "./js/tiny-mce-button";

// Can import modules as needed
// ex. import 'bootstrap/js/dist/dropdown';

import "./scss/style.scss";

// # ---------------------------------------------------------------
// # Custom Methods...
(function ($) {
  $(function () {
    // Custom Vimeo play button
    //

    // Using the Vimeo Player SDK
    //
    $(".video-play").click(function () {
      var player = new Player($(this).siblings("iframe"));
      player.play();
      $(this).hide();

      // Without the Vimeo Player SDK
      //
      // const player = $(this).siblings("iframe");
      // const data = { method: "play" };
      // player[0].contentWindow.postMessage(JSON.stringify(data), "*");
    });

    // Document Ready
    //
    $(document).ready(function () {
      // Play button needs to disappear also when
      // the video is played from the default controls

      $(".embed-container").each(function () {
        
        const wrapper = $(this);
        var player = new Player(wrapper.children("iframe"));

        player
          .getVideoId()
          .then(function (id) {
            // id = the video id
            // we will use this in a classname
            const stringID = "video-" + id.toString() + Math.floor(Math.random() * 100);

            // Add the class to to the wrapper and the play button
            // so that we can hide only the button associated with
            // this video.
            wrapper.addClass(stringID);
            wrapper.children(".video-play").addClass(stringID);
            wrapper.children("iframe").attr('video-id', stringID);
            // wrapper.data('video-id', stringID);
            // wrapper.children(".video-play").data('video-id', stringID);
          })
          .catch(function (error) {
            // an error occurred
          });

        // When the video is played from the default controls
        player.on("play", function () {
          player
            .getVideoId()
            .then(function (id, ) {

              // Get parent wrapper 
              // Do things with it

              // Create the same string ID
              const stringID = player.element.getAttribute('video-id');

              // And hide the button with the matching class
              $(".video-play." + stringID).hide();
              
            })
            .catch(function (error) {
              // an error occurred
            });
        });
      });

      // Since some accordions have a lot of content,
      // we need to scroll to the top of the panel
      // when they are opened.

      // This option has too much movement with the animation
      // TODO: Maybe best to just keep accordions open? 

      // $(".accordion .card-header .btn-link").click(function () {
        
      //   const card_body = $(this);

      //   setTimeout(function () {
      //     const panel = card_body.parents(".card").children('.panel');

      //     $("html,body").animate(
      //       {
      //         scrollTop: panel.offset().top -130,
      //       },
      //       300
      //     );
      //   }, 300);
      // });

    });
  });
})($);
